import { IWidgetSettings } from '@cloud-twin-v2/cloud-twin-shared/filtrable-items/widget-settings';
import { IntegrableForm } from '@common-modules/shared/forms/integrable-form';

export abstract class BaseDashboardSettingsComponent extends IntegrableForm {
  setExtraParams(params?: any): void {}
  abstract getWidgetSettings(): IWidgetSettings;
}
